<script lang="ts" setup>
import { ElDialog, ElDrawer, useZIndex } from 'element-plus'
import type { Component } from 'vue'

import RemoveIcon from '../../../assets/icons/remove.svg?component'
import { useMobileView } from '../../../hooks'

withDefaults(
  defineProps<{
    responsive?: boolean
    width?: string | number
    size?: string
    direction?: 'ltr' | 'rtl' | 'ttb' | 'btt'
    destroyOnClose?: boolean
    alignCenter?: boolean
    showClose?: boolean
    beforeClose?: () => void
    closeIcon?: Component
  }>(),
  {
    responsive: true,
    width: '600px',
    size: 'auto',
    direction: 'btt',
    destroyOnClose: false,
    alignCenter: false,
    showClose: true,
    beforeClose: undefined,
    closeIcon: RemoveIcon,
  },
)

const emits = defineEmits(['beforeClose'])
const { isMobileView } = useMobileView()
const { nextZIndex } = useZIndex()
const zIndex = nextZIndex()

const handleBeforeClose = () => {
  emits('beforeClose')
}
</script>

<template>
  <component
    :is="responsive && isMobileView ? ElDrawer : ElDialog"
    :model-value="true"
    :width="width"
    :size="size"
    :direction="direction"
    :align-center="alignCenter"
    :show-close="showClose"
    :destroy-on-close="destroyOnClose"
    :close-icon="closeIcon"
    :before-close="
      () => {
        beforeClose?.()
        handleBeforeClose()
      }
    "
    :z-index="zIndex"
  >
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <slot name="default" />
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </component>
</template>

<style lang="scss" scoped>
:deep(.el-dialog) {
  --el-dialog-padding-primary: 24px;

  .el-dialog__header {
    padding: 0;
    margin-right: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
